import { format } from 'date-fns';

import { Task } from '@atom/types/task';

import TaskCompletionIcon from './TaskCompletionIcon';

import classes from './workOrder.module.css';

export type TaskRowProps = {
  task: Task;
  showDateTime?: boolean;
};

const TaskRow = ({ task, showDateTime = false }: TaskRowProps) => {
  const dueDateLabel = showDateTime ? 'Due on' : 'Due Date:';
  const dueDateFormat = showDateTime ? 'MM/dd/yyyy hh:mm a' : 'MM/dd/yyyy';
  const dueDateText = task.dueDate ? format(task.dueDate, dueDateFormat) : '-';

  return (
    <div className={classes.taskRow}>
      <TaskCompletionIcon isCompleted={task.isCompleted} />
      <div className={classes.taskRowBody}>
        <div className={classes.taskName}>{task.name}</div>
        <div className={classes.taskMeta}>
          <span
            className={classes.taskMetaItem}
          >{`${dueDateLabel} ${dueDateText}`}</span>
          <span
            className={classes.taskMetaItem}
          >{`Team: ${task.users?.length ?? 0}`}</span>
        </div>
      </div>
    </div>
  );
};

export default TaskRow;
